import React, { Component } from 'react';
import { observer } from 'mobx-react';
import * as moment from 'moment/moment';
import WorkflowStepStateWaitingTransitionModal from '../workflow-step-state-waiting-transition-modal';
import WorkflowStepStateNaTransitionModal from '../workflow-step-state-na-transition-modal';
import { action, observable } from 'mobx';
import Cons from '../../../isomorphic/cons';
import TitleBar from './components/title-bar';

class WorkflowStepBaseViewStore {
    @observable isNaModalVisible = false;
    @observable isWaitingModalVisible = false;
    @observable transitionType = null;

    @action.bound
    hideNaModal() {
        this.isNaModalVisible = false;
    }

    @action.bound
    hideWaitingModal() {
        this.isWaitingModalVisible = false;
    }

    @action.bound
    showNaModal() {
        this.isNaModalVisible = true;
    }

    @action.bound
    showWaitingModal() {
        this.isWaitingModalVisible = true;
    }
}

@observer
export default class WorkflowStepBase extends Component {
    constructor(props) {
        super(props);
        this.viewStore = new WorkflowStepBaseViewStore();
    }

    updateStepState(step) {
        return this.props.appStore.workflowStore.updateWorkflowStep(step).then(() => {
            if (step.state.isComplete)
                this.props.appStore.analytics.trackWorkflowStepStateChanged(
                    this.props.appStore.tcFileStore.selectedFile,
                    step
                );
        });
    }

    //TODO:  This should be in an model
    saveNewStepTransition(transition) {
        const step = this.props.step;
        step.state.isSkipped = false;
        step.state.transitions.push(transition);
        this.updateStepState(step).then(() => {
            this.props.appStore.analytics.trackWorkflowStepStateChanged(
                this.props.appStore.tcFileStore.selectedFile,
                step,
                transition
            );
        });
    }

    render() {
        const step = this.props.step,
            accordionId = this.props.accordionId;

        const renderPanelBody = step => {
            if (step.state.isComplete) {
                return this.renderCompleteView(step);
            } else {
                return this.renderIncompleteView(step);
            }
        };

        const isOverdue = deadline => {
            return moment().isAfter(moment(deadline), 'day');
        };

        const isDue = deadline => {
            return (
                moment().isSame(moment(deadline), 'day') ||
                moment()
                    .add(1, 'days')
                    .isSame(moment(deadline), 'day')
            );
        };

        const getPanelClasses = (step, deadline) => {
            let panelClasses;

            if (step.state.isComplete) {
                panelClasses = 'panel panel-success';
            } else if (step.state.isSkipped) {
                panelClasses = 'panel panel-white';
            } else if (
                step.state.latestTransition &&
                step.state.latestTransition.status === Cons.transitionTypes.NotApplicable
            ) {
                panelClasses = 'panel panel-white';
            } else if (isDue(deadline)) {
                panelClasses = 'panel panel-orange';
            } else if (isOverdue(deadline)) {
                panelClasses = 'panel panel-danger';
            } else if (
                step.state.latestTransition &&
                step.state.latestTransition.status === Cons.transitionTypes.Waiting
            ) {
                panelClasses = 'panel panel-info';
            } else {
                panelClasses = 'panel panel-default';
            }

            return panelClasses;
        };

        return (
            <div className={getPanelClasses(step, this.props.deadlineCalculated)}>
                <div
                    className="panel-heading"
                    onClick={() => {
                        // this.props.appStore.analytics.trackWorkflowStepView(this.props.appStore.tcFileStore.selectedFile, step)
                    }}
                >
                    <h4 style={{ display: 'flex', overflow: 'hidden'}} className="panel-title">
                        <TitleBar
                            accordionId={accordionId}
                            step={step}
                            hideDueDate={this.props.hideDueDate}
                            deadlineCalculated={this.props.deadlineCalculated}
                        />
                    </h4>
                </div>
                <div id={step.stepId} className="panel-collapse collapse">
                    <div className="panel-body workflow">
                        <WorkflowStepStateNaTransitionModal
                            step={step}
                            saveNewStepTransition={this.saveNewStepTransition.bind(this)}
                            show={this.viewStore.isNaModalVisible}
                            hide={this.viewStore.hideNaModal}
                        />
                        <WorkflowStepStateWaitingTransitionModal
                            step={step}
                            saveNewStepTransition={this.saveNewStepTransition.bind(this)}
                            show={this.viewStore.isWaitingModalVisible}
                            hide={this.viewStore.hideWaitingModal}
                        />
                        {renderPanelBody(step)}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/workflow-step-base.js